import { LoadingIndicator } from "@laerdal/life-react-components";
import { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import styled from "styled-components";
import ProductApi from "../../services/api/ProductApi";
import { buildMarketPath, selectMarket } from "../../store/slices/globalConfigSlice";

const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
`;

const OnboardingRedirectPage = () => {
  const { productLink } = useParams<{ productLink: string }>();
  const navigate = useNavigate();
  const currentMarket = useSelector(selectMarket);
  const hasNavigated = useRef(false);

  useEffect(() => {
    if (!productLink || hasNavigated.current) return;

    let isActive = true;

    const resolve = async () => {
      try {
        const productLine = await ProductApi.GetProductLine(productLink);

        if (!isActive) return;

        if (productLine?.categoryLink && productLine?.linkName) {
          hasNavigated.current = true;
          const url = buildMarketPath(
            currentMarket,
            `/category/${productLine.categoryLink}/product/${productLine.linkName}/onboarding`
          );
          navigate(url, { replace: true });
          return;
        }
      } catch {
        // Product line not found
      }

      if (isActive) {
        hasNavigated.current = true;
        navigate(buildMarketPath(currentMarket, "/"), { replace: true });
      }
    };

    resolve();

    return () => {
      isActive = false;
    };
  }, [productLink, currentMarket]);

  return (
    <PageContainer>
      <LoadingIndicator />
    </PageContainer>
  );
};

export default OnboardingRedirectPage;
